<template>
  <div class="order-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单号">
          <el-input v-model="filterForm.order_dh" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="接单状态">
          <el-select v-model="filterForm.status_jie" placeholder="全部" clearable>
            <el-option label="可接单" value="可接单" />
            <el-option label="配货中" value="配货中" />
            <el-option label="已完成" value="已完成" />
            <el-option label="已作废" value="已作废" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable>
            <el-option label="待发货" value="待发货" />
            <el-option label="已发货" value="已发货" />
            <el-option label="退货中" value="退货中" />
            <el-option label="已处理" value="已处理" />
          </el-select>
        </el-form-item>
        <el-form-item label="付款状态">
          <el-select v-model="filterForm.pay_type" placeholder="全部" clearable>
            <el-option label="待付款" value="待付款" />
            <el-option label="已支付" value="已支付" />
            <el-option label="已退款" value="已退款" />
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button
            type="warning"
            icon="el-icon-document-add"
            :disabled="selectedOrders.length === 0"
            @click="showBatchDialog"
          >
            批量接单（{{ selectedOrders.length }}）
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 订单列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="orderList"
        height="56vh"
        border
        stripe
        @row-click="handleViewDetail"
        @selection-change="handleSelectionChange"
        row-key="id"
        style="width: 100%"
      >
        <el-table-column type="selection" width="55" :selectable="checkSelectable" />
        <el-table-column prop="order_dh" label="订单号" min-width="220" show-overflow-tooltip />
        <el-table-column prop="sh_img" label="店铺图片" width="100">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.sh_img"
              :preview-src-list="[scope.row.sh_img]"
              fit="cover"
              style="width: 40px; height: 40px; border-radius: 4px;"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="status_jie" label="接单状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getJieStatusType(scope.row.status_jie)" size="small">
              {{ scope.row.status_jie }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getOrderStatusType(scope.row.status)" size="small">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pay_type" label="付款状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getPayTypeType(scope.row.pay_type)" size="small">
              {{ scope.row.pay_type }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="quhuo" label="收货状态" width="100" />
        <el-table-column prop="comlist_f1" label="订单金额(元)" width="120">
          <template slot-scope="scope">
            <span class="money">¥{{ parseFloat(scope.row.comlist_f1).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="comlist_v6" label="支付方式" width="120" />
        <el-table-column prop="comlist3" label="下单时间" width="180" />
        <el-table-column label="操作" min-width="180" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click.stop="grabOrder(scope.row)"
              v-if="scope.row.status_jie === '可接单'"
            >
              接单
            </el-button>
            <el-button
              type="success"
              size="mini"
              icon="el-icon-edit-outline"
              @click.stop="openDispatchDialog(scope.row)"
              v-if="scope.row.status_jie === '配货中'"
            >
              派单
            </el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click.stop="openEditDialog(scope.row)"
            >
              取消订单
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="60%">
      <el-descriptions :column="2" border v-if="currentOrder">
        <el-descriptions-item label="订单号">{{ currentOrder.order_dh }}</el-descriptions-item>
        <el-descriptions-item label="店铺名称">{{ currentOrder.sh_name }}</el-descriptions-item>
        <el-descriptions-item label="接单状态">{{ currentOrder.status_jie }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ currentOrder.status }}</el-descriptions-item>
        <el-descriptions-item label="付款状态">{{ currentOrder.pay_type }}</el-descriptions-item>
        <el-descriptions-item label="收货状态">{{ currentOrder.quhuo }}</el-descriptions-item>
        <el-descriptions-item label="订单金额">
          <span class="money">¥{{ parseFloat(currentOrder.comlist_f1).toFixed(2) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="优惠金额">
          <span class="money"></span>
        </el-descriptions-item>
        <el-descriptions-item label="支付方式">{{ currentOrder.comlist_v6 }} ({{ currentOrder.comlist_v6_1 }})</el-descriptions-item>
        <el-descriptions-item label="下单时间">{{ currentOrder.comlist3 }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ currentOrder.comlist_v2 }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ currentOrder.comlist_v3 }}</el-descriptions-item>
        <el-descriptions-item label="提货方式">{{ currentOrder.comlist_v1 }}</el-descriptions-item>
        <el-descriptions-item label="期望提货日">{{ currentOrder.comlist_v5 }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 批量接单票据选择弹窗 -->
    <el-dialog
      title="批量接单"
      :visible.sync="batchDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="padding: 10px 0;">
        <p>已选择 <strong>{{ selectedOrders.length }}</strong> 个可接单订单，请选择票据类型：</p>
        <el-radio-group v-model="ticketType" style="margin-top: 15px;">
          <el-radio label="货物联">货物联</el-radio>
          <el-radio label="会计联">会计联</el-radio>
          <el-radio label="客户联">客户联</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer">
        <el-button @click="batchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatchGrab" :loading="batchLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 派单弹窗 -->
    <el-dialog
      title="派单"
      :visible.sync="dispatchDialogVisible"
      width="56.5%"
      :close-on-click-modal="false"
      @close="resetDispatchForm"
    >
      <div>
        <!-- 订单信息概要 -->
        <div style="margin-bottom: 15px; background: #f5f7fa; padding: 10px; border-radius: 4px;">
          <span>订单号：{{ dispatchOrder.order_dh }}</span>
          <span style="margin-left: 20px;">订单金额：¥{{ dispatchOrder.comlist_f1 }}</span>
          <span style="margin-left: 20px;">接单状态：{{ dispatchOrder.status_jie }}</span>
        </div>

        <!-- 派单条目表格（包含历史 + 新增） -->
        <el-table :data="dispatchItems" border style="width: 100%; margin-bottom: 15px;">
          <el-table-column label="序号" type="index" width="50" />
          <el-table-column label="经销商" width="180">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.jxId"
                placeholder="选择经销商"
                filterable
                :disabled="scope.row.isHistory"
                @change="onJxChange(scope.$index)"
              >
                <el-option
                  v-for="item in dealerList"
                  :key="item.id"
                  :label="item.sh_name"
                  :value="parseInt(item.id)"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="商品" width="200">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.goodsId"
                placeholder="选择商品"
                :disabled="scope.row.isHistory"
                @change="onGoodsChange(scope.$index)"
              >
                <el-option
                  v-for="item in orderProducts"
                  :key="item.id"
                  :label="item.name + '（总数量：' + item.quantity + '）'"
                  :value="parseInt(item.id)"
                  :disabled="getGoodsRemainQty(parseInt(item.id), scope.$index) <= 0 && !scope.row.isHistory"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="总数量" width="100">
            <template slot-scope="scope">
              {{ getGoodsTotalQty(scope.row.goodsId) }}
            </template>
          </el-table-column>
          <el-table-column label="已分配数量" width="100">
            <template slot-scope="scope">
              {{ getGoodsAllocatedQty(scope.row.goodsId, scope.$index) }}
            </template>
          </el-table-column>
          <el-table-column label="本次派单数量" width="150">
    <template slot-scope="scope">
      <!-- 历史条目：纯文本显示，不受 max 限制 -->
      <span v-if="scope.row.isHistory">{{ scope.row.quantity }}</span>
      <!-- 新增条目：可编辑 -->
      <el-input-number
        v-else
        v-model="scope.row.quantity"
        :min="1"
        :max="getGoodsRemainQty(scope.row.goodsId, scope.$index)"
        controls-position="right"
        size="small"
        @change="onQtyChange(scope.$index)"
      />
    </template>
        </el-table-column>
          <el-table-column label="单价" width="100">
            <template slot-scope="scope">
              {{ getGoodsPrice(scope.row.goodsId) }}
            </template>
          </el-table-column>
          <el-table-column label="小计" width="100">
            <template slot-scope="scope">
              {{ (scope.row.quantity * getGoodsPrice(scope.row.goodsId)).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isHistory" size="mini" type="info">历史</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" v-if="!hasHistoryOnly">
            <template slot-scope="scope">
              <el-button
                v-if="!scope.row.isHistory"
                type="danger"
                icon="el-icon-delete"
                size="mini"
                circle
                @click="removeDispatchItem(scope.$index)"
              />
            </template>
          </el-table-column>
        </el-table>

        <!-- 添加派单按钮 -->
        <div style="text-align: left; margin-bottom: 15px;">
          <el-button type="primary" icon="el-icon-plus" @click="addDispatchItem" :disabled="allGoodsAllocated">
            添加派单
          </el-button>
          <span v-if="allGoodsAllocated" style="color: #999; margin-left: 10px;">所有商品已分配完毕</span>
        </div>

        <!-- 汇总信息 -->
        <div style="background: #f0f9eb; padding: 10px; border-radius: 4px;">
          <span>派单总数量（含历史）：{{ totalDispatchQty }}</span>
          <span style="margin-left: 20px;">派单总金额（含历史）：¥{{ totalDispatchAmount.toFixed(2) }}</span>
          <span style="margin-left: 20px;">本次新增派单数量：{{ newDispatchQty }}</span>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dispatchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDispatch" :loading="dispatchSubmitting">提 交 派 单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'OrderList',
  data () {
    return {
      loading: false,
      orderList: [],
      filterForm: {
        order_dh: '',
        status_jie: '',
        status: '',
        pay_type: '',
        start_time: '',
        end_time: ''
      },
      dateRange: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      dialogVisible: false,
      currentOrder: null,

      // 批量接单
      selectedOrders: [],
      batchDialogVisible: false,
      ticketType: '货物联',
      batchLoading: false,

      // 派单相关
      dispatchDialogVisible: false,
      dispatchOrder: {}, // 当前要派单的订单
      orderProducts: [], // 订单商品列表
      dealerList: [], // 经销商列表
      dispatchItems: [], // 派单条目数组（含历史和新增）
      dispatchSubmitting: false,
      historyLoaded: false // 标记历史是否加载完成
    }
  },
  computed: {
    // 总派单数量（含历史）
    totalDispatchQty () {
      return this.dispatchItems.reduce((sum, item) => sum + (item.quantity || 0), 0)
    },
    // 总派单金额（含历史）
    totalDispatchAmount () {
      return this.dispatchItems.reduce((sum, item) => {
        const price = this.getGoodsPrice(item.goodsId)
        return sum + (item.quantity || 0) * price
      }, 0)
    },
    // 新增派单数量（不含历史）
    newDispatchQty () {
      return this.dispatchItems
        .filter(item => !item.isHistory)
        .reduce((sum, item) => sum + (item.quantity || 0), 0)
    },
    // 判断是否所有商品都已分配完（剩余为0）
    allGoodsAllocated () {
      if (this.orderProducts.length === 0) return false
      // 检查每个商品，如果所有商品的剩余可分配数量都为0，则返回true
      return this.orderProducts.every(product => {
        const remain = this.getGoodsRemainQty(parseInt(product.id), -1) // -1表示不排除任何条目
        return remain <= 0
      })
    },
    // 是否存在只有历史记录的情况（用于隐藏操作列）
    hasHistoryOnly () {
      return this.dispatchItems.every(item => item.isHistory)
    }
  },
  mounted () {
    this.getOrderList()
  },
  methods: {
    // ----- 原有方法（保留） -----
    async grabOrder (row) {
      const userType = localStorage.getItem('user_type')
      const userId = localStorage.getItem('user_id')
      const params = {
        order_id: row.id,
        user_type: userType,
        user_id: userId
      }
      try {
        const res = await request.post('/order/grab_order.php', params)
        if (res.code === 0) {
          this.$message.success('接单成功')
          this.getOrderList()
        } else {
          this.$message.error(res.msg || '接单失败')
        }
      } catch (err) {
        console.error('接单异常:', err)
        this.$message.error('接单异常，请重试')
      }
    },

    async getOrderList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize,
          ...this.filterForm,
          sh_id: localStorage.getItem('sh_id')
        }
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })
        const response = await request.post('/common/merchant.php?a=getOrders', { ...params })

        if (response.code === '0') {
          this.orderList = response.res || []
          this.pages = response.pages || 0
          this.total = this.pages * this.pageSize
        } else if (response.code === 1001) {
          this.$message.error('请先登录')
          this.orderList = []
          this.total = 0
        } else {
          this.$message.error(response.msg || '获取订单列表失败')
          this.orderList = []
          this.total = 0
        }
      } catch (error) {
        console.error('请求订单列表出错:', error)
        this.$message.error('网络错误，请稍后重试')
        this.orderList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      if (this.dateRange && this.dateRange.length === 2) {
        this.filterForm.start_time = this.dateRange[0]
        this.filterForm.end_time = this.dateRange[1]
      } else {
        this.filterForm.start_time = ''
        this.filterForm.end_time = ''
      }
      this.currentPage = 1
      this.getOrderList()
    },

    handleReset () {
      this.filterForm = {
        order_dh: '',
        status_jie: '',
        status: '',
        pay_type: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      this.currentPage = 1
      this.getOrderList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getOrderList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getOrderList()
    },

    handleViewDetail (row) {
      this.currentOrder = row
      this.dialogVisible = true
    },

    getJieStatusType (status) {
      const map = { 可接单: 'success', 配货中: 'warning', 已完成: 'info', 已作废: 'danger' }
      return map[status] || 'info'
    },
    getOrderStatusType (status) {
      const map = { 待发货: 'warning', 已发货: 'success', 退货中: 'danger', 已处理: 'info' }
      return map[status] || 'info'
    },
    getPayTypeType (payType) {
      const map = { 待付款: 'danger', 已支付: 'success', 已退款: 'warning' }
      return map[payType] || 'info'
    },

    // ----- 批量接单相关 -----
    checkSelectable (row) { return row.status_jie === '可接单' },
    handleSelectionChange (selection) { this.selectedOrders = selection },
    showBatchDialog () {
      if (this.selectedOrders.length === 0) {
        this.$message.warning('请先选择需要接单的订单')
        return
      }
      const invalid = this.selectedOrders.some(o => o.status_jie !== '可接单')
      if (invalid) {
        this.$message.error('存在不可接单的订单，请重新选择')
        this.selectedOrders = []
        return
      }
      this.batchDialogVisible = true
    },
    async confirmBatchGrab () {
      this.batchLoading = true
      try {
        const shId = localStorage.getItem('sh_id')
        const userType = localStorage.getItem('user_type')
        const userPhone = localStorage.getItem('user_phone')
        const workId = localStorage.getItem('work_id')
        const userId = localStorage.getItem('user_id')
        let selectedPrinter = {}
        try {
          selectedPrinter = JSON.parse(localStorage.getItem('selected_printer') || '{}')
        } catch (e) {
          selectedPrinter = {}
        }

        if (!shId || !userType || !userId) {
          this.$message.error('缺少用户信息，请重新登录')
          return
        }
        if (!selectedPrinter.machine_code) {
          this.$message.error('请先设置默认打印机')
          return
        }

        const orderIds = this.selectedOrders.map(o => o.id)

        const params = {
          order_ids: orderIds,
          sh_id: shId,
          user_type: userType,
          user_phone: userPhone || '',
          work_id: workId || '',
          user_id: userId,
          selectedPay: '小程序支付',
          print_type: this.ticketType,
          machine_code: selectedPrinter.machine_code
        }

        const res = await request.post('/include/printer/printer_order_he.php', params)

        if (res.code === 0) {
          this.$message.success(`批量接单成功，共 ${orderIds.length} 个订单`)
          this.batchDialogVisible = false
          this.selectedOrders = []
          this.getOrderList()
        } else {
          this.$message.error(res.msg || '批量接单失败')
        }
      } catch (err) {
        console.error('批量接单异常:', err)
        this.$message.error('批量接单异常，请稍后重试')
      } finally {
        this.batchLoading = false
      }
    },

    // ----- 派单功能（含历史派单回显） -----
    // 打开派单弹窗
    async openDispatchDialog (row) {
      this.dispatchOrder = row
      this.dispatchItems = [] // 先清空
      this.dispatchDialogVisible = true

      // 并行加载：订单商品、经销商列表、历史派单
      await Promise.all([
        this.fetchOrderProducts(row.id),
        this.fetchDealerList(),
        this.fetchHistoryDispatch(row.id)
      ])

      // 如果没有历史记录，添加一个默认空条目
      if (this.dispatchItems.length === 0) {
        this.addDispatchItem()
      }
    },

    // 获取订单商品详情
    async fetchOrderProducts (orderId) {
      try {
        const storeId = localStorage.getItem('sh_id')
        const userType = localStorage.getItem('user_type')
        const res = await request.post('/order/qiang_jiben_list.php', {
          order_id: orderId,
          store_id: storeId,
          user_type: userType
        })
        if (res.code === 0) {
          this.orderProducts = res.data.products || []
        } else {
          this.$message.error(res.msg || '获取订单商品失败')
          this.orderProducts = []
        }
      } catch (err) {
        console.error('获取订单商品失败:', err)
        this.$message.error('获取订单商品失败')
        this.orderProducts = []
      }
    },

    // 获取经销商列表
    async fetchDealerList () {
      try {
        const shId = localStorage.getItem('sh_id')
        const res = await request.post('/admin/shenhe_jiben.php', {
          a: 'lists',
          sh_id: shId,
          page: 1,
          page_size: 200,
          sh_name: '',
          id: '',
          sh_type: '审核通过'
        })
        if (res.code === '0') {
          this.dealerList = res.data || []
        } else {
          this.$message.error(res.msg || '获取经销商列表失败')
          this.dealerList = []
        }
      } catch (err) {
        console.error('获取经销商列表失败:', err)
        this.$message.error('获取经销商列表失败')
        this.dealerList = []
      }
    },

    // 获取历史派单记录
    async fetchHistoryDispatch (orderId) {
      try {
        const shId = localStorage.getItem('sh_id')
        const res = await request.post('/order/order_pai.php', {
          a: 'paiLists',
          sh_id: shId,
          order_id: orderId,
          page: 1,
          page_size: 20
        })
        if (res.code === '0' && res.data && res.data.length > 0) {
          const historyItems = []
          res.data.forEach(record => {
            if (record.mx && record.mx.length) {
              record.mx.forEach(goods => {
                historyItems.push({
                  isHistory: true,
                  jxId: parseInt(record.jx_id, 10),
                  goodsId: parseInt(goods.goods_id, 10),
                  quantity: parseInt(goods.comlist_s1, 10), // ✅ 转为数字
                  paiOrderNo: record.pai_order_no,
                  historyGoodsName: goods.goods_name,
                  historyPrice: parseFloat(goods.comlist_f1)
                })
              })
            }
          })
          this.dispatchItems = historyItems
        }
      } catch (err) {
        console.error('获取历史派单失败:', err)
      }
    },
    // 添加派单条目（新增）
    addDispatchItem () {
      // 判断是否所有商品已分配完，若是则不允许添加
      if (this.allGoodsAllocated) {
        this.$message.warning('所有商品已分配完毕，无法继续派单')
        return
      }
      this.dispatchItems.push({
        isHistory: false,
        jxId: null,
        goodsId: null,
        quantity: 1
      })
    },

    // 删除派单条目（仅允许删除非历史）
    removeDispatchItem (index) {
      const item = this.dispatchItems[index]
      if (item.isHistory) {
        this.$message.warning('历史派单不可删除')
        return
      }
      if (this.dispatchItems.filter(i => !i.isHistory).length <= 1) {
        this.$message.warning('至少保留一个新增派单条目')
        return
      }
      this.dispatchItems.splice(index, 1)
    },

    // 经销商变化
    onJxChange (index) {
      // 可做额外处理
    },

    // 商品变化
    onGoodsChange (index) {
      // 重置数量为1，并校验
      this.dispatchItems[index].quantity = 1
      const remain = this.getGoodsRemainQty(this.dispatchItems[index].goodsId, index)
      if (remain <= 0) {
        this.$message.warning('该商品已无剩余可分配数量')
        this.dispatchItems[index].goodsId = null
        this.dispatchItems[index].quantity = 1
      }
    },

    // 数量变化
    onQtyChange (index) {
      const item = this.dispatchItems[index]
      if (!item.goodsId) return
      const remain = this.getGoodsRemainQty(item.goodsId, index)
      if (item.quantity > remain) {
        this.$message.warning(`数量不能超过剩余可分配数量 ${remain}`)
        item.quantity = remain
      }
    },

    // 获取某个商品的总数量
    getGoodsTotalQty (goodsId) {
      if (!goodsId) return 0
      const product = this.orderProducts.find(p => parseInt(p.id) === goodsId)
      return product ? product.quantity : 0
    },

    // 获取某个商品的单价
    getGoodsPrice (goodsId) {
      if (!goodsId) return 0
      // 优先从历史记录中取单价（历史记录可能单价不同）
      const historyItem = this.dispatchItems.find(item => item.isHistory && item.goodsId === goodsId)
      if (historyItem && historyItem.historyPrice !== undefined) {
        return parseFloat(historyItem.historyPrice)
      }
      const product = this.orderProducts.find(p => parseInt(p.id) === goodsId)
      return product ? parseFloat(product.unit_price) : 0
    },

    // 获取某个商品已分配的总数量（包含历史 + 其他新增条目，排除自身）
    getGoodsAllocatedQty (goodsId, currentIndex) {
      if (!goodsId) return 0
      let total = 0
      this.dispatchItems.forEach((item, idx) => {
        if (idx !== currentIndex && item.goodsId === goodsId && item.quantity) {
          total += item.quantity
        }
      })
      return total
    },

    // 获取某个商品剩余可分配数量
    getGoodsRemainQty (goodsId, currentIndex) {
      const total = this.getGoodsTotalQty(goodsId)
      const allocated = this.getGoodsAllocatedQty(goodsId, currentIndex)
      return Math.max(0, total - allocated)
    },

    // 重置派单表单
    resetDispatchForm () {
      this.dispatchItems = []
      this.orderProducts = []
      this.dealerList = []
      this.dispatchOrder = {}
      this.historyLoaded = false
    },

    // 提交派单（仅提交新增派单）
    async submitDispatch () {
      // 过滤出新增派单条目
      const newItems = this.dispatchItems.filter(item => !item.isHistory)

      // 校验新增条目
      for (let i = 0; i < newItems.length; i++) {
        const item = newItems[i]
        if (!item.jxId) {
          this.$message.warning(`第 ${i + 1} 个新增派单未选择经销商`)
          return
        }
        if (!item.goodsId) {
          this.$message.warning(`第 ${i + 1} 个新增派单未选择商品`)
          return
        }
        if (!item.quantity || item.quantity <= 0) {
          this.$message.warning(`第 ${i + 1} 个新增派单数量必须大于0`)
          return
        }
        // 校验数量不超过剩余可分配（含历史）
        const remain = this.getGoodsRemainQty(item.goodsId, this.dispatchItems.indexOf(item))
        if (item.quantity > remain) {
          this.$message.warning(`商品 ${this.getGoodsName(item.goodsId)} 数量超出剩余可分配数量 ${remain}`)
          return
        }
      }

      if (newItems.length === 0) {
        this.$message.warning('没有新增派单需要提交')
        return
      }

      // 按经销商分组
      const groupMap = new Map()
      newItems.forEach(item => {
        const jxId = item.jxId
        if (!groupMap.has(jxId)) {
          groupMap.set(jxId, {
            jx_id: jxId,
            pai_order_no: this.generateOrderNo(),
            comlist_s1: 0,
            comlist_f1: 0,
            goods_list: []
          })
        }
        const group = groupMap.get(jxId)
        const goods = this.orderProducts.find(p => parseInt(p.id) === item.goodsId)
        const price = parseFloat(goods.unit_price) || 0
        const qty = item.quantity
        const amount = qty * price
        group.comlist_s1 += qty
        group.comlist_f1 += amount
        group.goods_list.push({
          order_mx_id: parseInt(goods.id),
          goods_id: parseInt(goods.id),
          goods_name: goods.name,
          comlist_s1: qty,
          comlist_f1: price
        })
      })

      const list = Array.from(groupMap.values())

      const params = {
        a: 'pai',
        sh_id: parseInt(localStorage.getItem('sh_id')),
        order_id: parseInt(this.dispatchOrder.id),
        list: list
      }

      this.dispatchSubmitting = true
      try {
        const res = await request.post('/order/order_pai.php', params)
        if (res.code === '0') {
          this.$message.success('派单成功')
          this.dispatchDialogVisible = false
          // 刷新列表
          this.getOrderList()
        } else {
          this.$message.error(res.msg || '派单失败')
        }
      } catch (err) {
        console.error('派单异常:', err)
        this.$message.error('派单异常，请稍后重试')
      } finally {
        this.dispatchSubmitting = false
      }
    },

    // 生成派单编号
    generateOrderNo () {
      const now = new Date()
      const dateStr =
        now.getFullYear() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') +
        String(now.getHours()).padStart(2, '0') +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getSeconds()).padStart(2, '0')
      const random = String(Math.floor(Math.random() * 1000000)).padStart(6, '0')
      return 'P' + dateStr + random
    },

    // 辅助：根据goodsId获取商品名称
    getGoodsName (goodsId) {
      const product = this.orderProducts.find(p => parseInt(p.id) === goodsId)
      return product ? product.name : ''
    },

    // 原占位方法（取消订单）
    openEditDialog (row) {
      this.$message.info('取消订单功能开发中')
    }
  }
}
</script>

<style lang="scss" scoped>
.money { color: #ee530c; }
.order-container {
  padding: 0 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card { .filter-form { margin-bottom: 0; } }
  .table-card {
    .pagination { margin-top: 20px; text-align: right; }
    .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px; height: 40px;
      background-color: #f5f7fa;
      color: #909399;
      font-size: 20px;
    }
  }
}
</style>
